import template from './resolvable-geo-location.html';

class geoLocationController {
  constructor(gettextCatalog, $q, browser, $state) {
    'ngInject';
    this.gettextCatalog = gettextCatalog;
    this.address = '';
    this.coords = '';
    this.displayAddress = false;
    this.$q = $q;
    this.mapURL = '#';
    this.browser = browser;
    this.addToDataLayer = (data) => window.dataLayer.push(data);
    this.$state = $state;
  }

  $onInit() {
    this.IsIOSDevice = (this.browser.osname || '').toLowerCase() === 'ios';
    this.updateCoords();
    this.setMapURL();
  }

  $onChanges() {
    this.address = '';
    this.updateCoords();
    this.setMapURL();
  }

  setMapURL() {
    const universalGoogleMapUrlDirection = encodeURI(
      `https://www.google.com/maps/dir/?api=1&destination=${this.latitude},${this.longitude}`
    );
    const universalGoogleMapUrl = encodeURI(
      `https://www.google.com/maps/search/?api=1&query=${this.latitude},${this.longitude}`
    );
    const isoMapDirection = encodeURI(`http://maps.apple.com/?daddr=${this.latitude},${this.longitude}`);
    const isoMap = encodeURI(`http://maps.apple.com/?q=${this.latitude},${this.longitude}`);
    this.mapURL = this.IsIOSDevice ? isoMap : universalGoogleMapUrl;
    this.mapURLDirection = this.IsIOSDevice ? isoMapDirection : universalGoogleMapUrlDirection;
  }

  updateCoords() {
    this.coords = `${Number(this.latitude).toFixed(5)},${Number(this.longitude).toFixed(5)}`;
  }

  handleRsolveResult(error, result) {
    if (error) {
      this.updateLocation(this.gettextCatalog.getString('Unknown Address'));
    } else if (result.address.Match_addr) {
      this.updateLocation(result.address.Match_addr);
    } else {
      const closeAddress = `${this.gettextCatalog.getString('Closest Address ')}:${result.address.Address}`;
      this.updateLocation(closeAddress);
    }
  }

  resolveCoord() {
    return this.$q(resolve => {
      L.esri.Geocoding.reverseGeocode()
        .latlng([this.latitude, this.longitude])
        .distance(5000)
        .language('EN')
        .run((error, result) => {
          if (error) {
            resolve(this.gettextCatalog.getString('Unknown Address'));
          } else if (result.address.Match_addr) {
            resolve(result.address.Match_addr);
          } else {
            const closeAddress = `${this.gettextCatalog.getString('Closest Address ')}:${result.address.Address}`;
            resolve(closeAddress);
          }
        });
    });
  }

  getLocation() {
    return this.displayAddress ? this.address || this.coords : this.coords;
  }

  toggleCoordAddress() {
    const eventData = { displayAddress: true, page: this.$state.current.name };

    if (!this.displayAddress) {
      !this.address
        ? this.resolveCoord().then(address => {
            this.address = address;
            //delay set displayAddress til resolve call get back
            this.displayAddress = true;
          })
        : (this.displayAddress = true);
    } else {
      this.displayAddress = false;
      eventData.displayAddress = false;
    }

    this.addToDataLayer({
      event: 'toggleCoordAddress',
      data: eventData,
    });
  }
}

export default {
  template,
  bindings: {
    latitude: '<',
    longitude: '<',
    lastSeen: '<?'
  },
  controller: geoLocationController,
  controllerAs: 'vm'
};
